import React from 'react'
import Section from '../../components/section/section'
import './about-page.css'

const AboutPage = () => (
	<Section title="About" id="about">
			<div className="body-text">
			I bought Char's Hot Dogs January 4, 2016 from Charlene Herd that had the business for almost 20 years.
			I had always wanted to own my own restaurant after working in restaurants for almost 30 years I finally did it.
			I knew restaurant work was my thing when I was young and use to play restaurant with my grandma and grandpa. I wish that they could be here and see that I finally did it.
			Working in Benicia inside the historic Tannery Building has been a dream, and I hope to continue serving the city for many more years.
			Thank you for your support!
			</div>
	</Section>
)

export default AboutPage
